export enum BillingId {
  ANNUAL = 'bc:5',
  INSTALLMENT = 'bc:7',
}
